import { render, staticRenderFns } from "./MFA.vue?vue&type=template&id=880ef8c4&scoped=true&"
import script from "./MFA.vue?vue&type=script&lang=js&"
export * from "./MFA.vue?vue&type=script&lang=js&"
import style0 from "./MFA.vue?vue&type=style&index=0&id=880ef8c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880ef8c4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('880ef8c4')) {
      api.createRecord('880ef8c4', component.options)
    } else {
      api.reload('880ef8c4', component.options)
    }
    module.hot.accept("./MFA.vue?vue&type=template&id=880ef8c4&scoped=true&", function () {
      api.rerender('880ef8c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MFA.vue"
export default component.exports